export { default as NButton, XButton as NxButton, buttonProps } from './src/Button';
